import type { AbilityLevel, PermanentState } from "../types"
import { abilities } from "../game/content"
import { getAbilityLevel } from "../game/abilityEngine"
import { getAbilitySpriteStyle } from "../game/sprites"

interface SkillsScreenProps {
  permanent: PermanentState
  onBack: () => void
}

const LEVEL_LABEL: Record<AbilityLevel, string> = {
  none: "Not Learned",
  beginner: "Beginner",
  advanced: "Advanced",
  master: "Master",
}

export function SkillsScreen({ permanent, onBack }: SkillsScreenProps) {
  return (
    <div className="screen skills-screen">
      <h1>Skills</h1>
      <p className="journal-intro">
        Every skill worth learning in this life, and how far this one has come.
      </p>

      <ul className="journal-ability-list">
        {abilities.map((ability) => {
          const level = getAbilityLevel(permanent, ability.id)
          const spriteStyle = getAbilitySpriteStyle(ability.id)
          return (
            <li
              key={ability.id}
              className={`journal-ability${
                level === "none" ? " journal-ability-unlearned" : ""
              }`}
            >
              {spriteStyle && (
                <div
                  className="ability-icon"
                  style={spriteStyle}
                  role="img"
                  aria-label={ability.name}
                />
              )}
              <div className="journal-ability-body">
                <h3>
                  {ability.name}{" "}
                  <span className="journal-ability-level">— {LEVEL_LABEL[level]}</span>
                </h3>
                <p>{ability.description}</p>
              </div>
            </li>
          )
        })}
      </ul>

      <button type="button" onClick={onBack}>
        Back to Map
      </button>
    </div>
  )
}
